/**
 * Translate description: Filter component
 */

import { Fragment, useContext, useEffect, useState } from 'react';

import { useLanguageContext, langByCode } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import { InputSearchAjax } from "../InputSearchAjax";

import { Crud } from '../../utils/crud';
const crud = new Crud('users');

export default () => {
  const { t } = useLanguageContext();
  const { filter, setFilter, setPaginator, currentLang } = useContext(AppContext);
  const [user, setUser] = useState([]);

  const loadData = async () => {
    try {
      const res = (await crud.get({}))?.data ?? [];
      setUser(res);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    loadData();
  }, []);


  return (
    <Fragment>
      <FormControl size="sm">
        <FormLabel>{t('User')}</FormLabel>
        <InputSearchAjax onChange={(e, v) => {
          if (!e) return;
          if (v) {
            setFilter({ ...filter, user_id: [v.id] });
          } else {
            let _f = filter;
            if (_f.users) delete _f.users;
            setFilter({ ..._f });
          }
          setPaginator({ currentPage: 1 });
        }} url='/users/all' field="login" lang_id={langByCode(currentLang).id} debouncetimeout="500" defaultValue={null} minLength="0" isOptionEqualToValue={((o, v) => o.id === v?.id)} clearOnBlur={true} />
      </FormControl>
    </Fragment>
  )
};
